module.exports = __webpack_public_path__ + "static/img/c3.d003df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insideCamp/c3.png
// module id = CoEp
// module chunks = 0